import React, { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  organizationNumber?: string;
  legalName?: string;
};

const BusinessInformation: FunctionComponent<Props> = ({ organizationNumber, legalName }) => {
  const { t } = useTranslation(['retailer']);
  const hasOrganizationNumber = !!organizationNumber;
  const hasLegalName = !!legalName;

  const shouldHide = !hasOrganizationNumber && !hasLegalName;
  if (shouldHide) {
    return null;
  }

  return (
    <div className="m-t-double">
      <h3 className="h4">{t('companyInformation', { ns: 'retailer' })}</h3>
      {hasLegalName && <div>{legalName}</div>}
      {hasOrganizationNumber && (
        <div className="m-t-mini">
          <span className="font-medium">{t('organizationNumberShort', { ns: 'retailer' })}: </span>
          <span>{organizationNumber}</span>
        </div>
      )}
    </div>
  );
};

export default BusinessInformation;
